<ul class="menu-items">
  <div class="menu-items__graphics" *ngIf="menuItems.type === 'Gráficas'">
    <span class="menu-items__subtitle">{{ 'SPAN.Gráficas' | translate }} </span>
    <li *ngFor="let item of menuItems.items">
      <a [routerLink]="item.route" routerLinkActive="item__active" (click)="onItemClick(item)">{{ 'MENU.' + item.item | translate }}</a>
    </li>
  </div>

  <div class="menu-items__reports" *ngIf="menuItems.type === 'Reportes'">
    <span class="menu-items__subtitle">{{ 'SPAN.Reportes' | translate }}</span>
    <li *ngFor="let item of menuItems.items">
      <a [routerLink]="item.route" routerLinkActive="item__active" (click)="onItemClick(item)">{{ 'MENU.' + item.item | translate }}</a>
    </li>
  </div>

  <div class="menu-items__section" *ngIf="menuItems.type === 'Módulo'">
    <li *ngFor="let item of menuItems.items">
      <a [routerLink]="item.route" routerLinkActive="item__active" (click)="onItemClick(item)">{{ 'MENU.' + item.item | translate }}</a>
    </li>
  </div>
</ul>
